module.exports = __webpack_public_path__ + "media/images/front/icon_note-8fcec6778cc3be172014fae4fe85bda1.png";